import React from "react";

import { Box } from "styles/globalComponents";

import { Button } from "Components/Button";
import Select from "Components/Form/Select";

import { useFilters } from "Pages/PreBudgetConvertion/hooks/useFilters";
import { useItemsContext } from "Pages/PreBudgetConvertion/hooks/useItemsContext";
import { InputOverlayProductList } from "./InputOverlayList";
import { BudgetFiltersProps } from "./interface";
import { SearchInput, SearchFilters, FiltersContainer } from "./styles";

export const PreOrderFilters = ({
  getProducts,
  fetchNewPage,
  clearFetchedData,
}: BudgetFiltersProps) => {
  const {
    handleTypeSearch,
    search,
    subcategoriesOpts,
    categoriesOpts,
    handleChangeFilter,
    clearFilter,
    loadingCombos,
  } = useFilters();

  const { blockUserInteraction } = useItemsContext();

  const submit = (e: any) => {
    e.preventDefault();
    getProducts({ ...search });
    fetchNewPage(1);
  };

  const clearFilters = () => {
    clearFilter();
    clearFetchedData({
      categories: "1,2,3",
      search: "",
      subcategories: "",
      services: "4",
    });
  };

  const handleSearchProducts = () => {
    const productsFilter = {
      ...search,
    };
    getProducts(productsFilter);
  };

  return (
    <FiltersContainer>
      <SearchFilters className="row" onSubmit={submit}>
        <>
          <p className="filter-by">Filtrar por: </p>

          <Box className="w-select">
            <Select
              id="category"
              value={search?.categories}
              readOnly={!categoriesOpts?.length || blockUserInteraction}
              optionName="category"
              placeholder="Categoria"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChangeFilter("categories", e.target.value)
              }
              options={categoriesOpts}
            />
          </Box>

          {subcategoriesOpts && subcategoriesOpts.length >= 1 && (
            <Box className="w-select">
              {/* @ts-ignore */}
              <Select
                id="subCategory"
                value={search?.subcategories}
                placeholder="Subcategoria"
                optionName="subcategory"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeFilter("subcategories", e.target.value)
                }
                options={subcategoriesOpts}
              />
            </Box>
          )}
        </>

        <Box display="flex" justify="center" className="container-btn-actions">
          <Button
            classButton="action-btn"
            type="button"
            onClick={clearFilters}
            outlined
            disabled={
              loadingCombos ||
              categoriesOpts?.length === 0 ||
              blockUserInteraction
            }
          >
            Limpar
          </Button>
          <Button
            type="submit"
            classButton="action-btn"
            disabled={
              loadingCombos ||
              categoriesOpts?.length === 0 ||
              blockUserInteraction
            }
          >
            Filtrar
          </Button>
        </Box>
      </SearchFilters>

      <SearchInput className="row">
        <div className="sm-12 ">
          <InputOverlayProductList
            handleTypeSearch={handleTypeSearch}
            filters={search}
            handleSearchProducts={handleSearchProducts}
            blockUserInteraction={blockUserInteraction}
          />
        </div>
      </SearchInput>
    </FiltersContainer>
  );
};
